module.exports = __webpack_public_path__ + "images/img-3jYeW9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/country.jpg
// module id = 1992
// module chunks = 0